/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_No_Event_SelectedInputs */

const en_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No event selected. Please select an event first.`)
};

const fr_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement sélectionné. Veuillez d'abord sélectionner un événement.`)
};

const de_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde keine Veranstaltung ausgewählt. Bitte wählen Sie zuerst eine Veranstaltung aus.`)
};

const it_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento selezionato. Seleziona prima un evento.`)
};

const ru_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятие не выбрано. Пожалуйста, сначала выберите мероприятие.`)
};

const es_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún evento. Seleccione primero un evento.`)
};

const zh_cn2_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何活动。请先选择一个活动。`)
};

const ja_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントが選択されていません。まずイベントを選択してください。`)
};

const hi_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट नहीं चुना गया है। कृपया पहले एक इवेंट चुनें।`)
};

const pt_pt2_audio_recorder_no_event_selected = /** @type {(inputs: Audio_Recorder_No_Event_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento selecionado. Por favor, selecione um evento primeiro.`)
};

/**
* | output |
* | --- |
* | "No event selected. Please select an event first." |
*
* @param {Audio_Recorder_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_no_event_selected = /** @type {((inputs?: Audio_Recorder_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_no_event_selected(inputs)
	if (locale === "de") return de_audio_recorder_no_event_selected(inputs)
	if (locale === "it") return it_audio_recorder_no_event_selected(inputs)
	if (locale === "ru") return ru_audio_recorder_no_event_selected(inputs)
	if (locale === "es") return es_audio_recorder_no_event_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_no_event_selected(inputs)
	if (locale === "ja") return ja_audio_recorder_no_event_selected(inputs)
	if (locale === "hi") return hi_audio_recorder_no_event_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_no_event_selected(inputs)
	return en_audio_recorder_no_event_selected(inputs)
});